import {combineReducers} from "redux";

import listeOffresReducer from "./listeOffres";


export default combineReducers({
    listeOffres : listeOffresReducer
});